/* eslint-disable */

/** unique or primary key constraints on table "argo.material_class_attribute_setting" */
export enum ArgoMaterialClassAttributeSettingConstraint {
  /** unique or primary key constraint on columns "material_class_attribute_setting_id" */
  MaterialClassAttributeSettingPkey = 'material_class_attribute_setting_pkey'
}

/** select columns of table "argo.material_class_attribute_setting" */
export enum ArgoMaterialClassAttributeSettingSelectColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.material_class_attribute_setting" */
export enum ArgoMaterialClassAttributeSettingUpdateColumn {
  /** column name */
  AttributeSchemaId = 'attribute_schema_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

